export enum Hotkeys {
  toggleFullscreen = 'Alt+F, F',
  togglePlay = 'Space, K',
  toggleMute = 'Alt+M, M',
  goToLive = 'Alt+L',
  volumeUp = 'ArrowUp',
  volumeDown = 'ArrowDown',
  seekForward = 'ArrowRight',
  seekBackward = 'ArrowLeft',
  console = 'intlbackslash, backquote',
  // createClip = 'Alt+C',
}
